import cn from 'classnames';
import {Swiper, SwiperSlide} from 'swiper/react';
import {useState, useCallback} from 'preact/hooks';

import {NormalBtn} from './components';
import styles from '~/style/aigallery/banner.module.less';
import stylesCommon from '~/style/aigallery/common.module.less';
import {banner as data} from '~/locals/aigallery/index';
import {useCptDuration} from '~/utils/trackCptDuration/hook';
import {applicationName} from '~/utils/trackCptDuration/constants';

import '~/style/aigallery/index.less';

const bannerSwiperConfig = {
    slidesPerView: 1,
    loop: true,
    speed: 1000,
    observer: true,
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true
        // type: 'progressbar'
    },
    autoplay: {
        delay: 8000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
    },
    simulateTouch: false,
    spaceBetween: 0
};
const id = 'qianfanBanner';
const BannerSlide = ({data}) => {
    const {title, title_m, title_ipad, desc, btnList, slideName, noticeList} = data;
    const notice = noticeList && noticeList[0];
    return (
        <div className={cn(styles[slideName], styles['banner-info-wrapper'], 'banner-info-wrapper')}>
            {notice && (
                <a href={notice.link} target="_blank" className={styles['banner-notice']} {...notice.trackInfo}>
                    <img src={notice.icon} alt="" />
                    {notice.desc}
                    {notice.afterIcon}
                </a>
            )}
            <h1 className={stylesCommon['title-pc']}>{title}</h1>
            <h1 className={stylesCommon['title-ipad']}>{title_ipad || title}</h1>
            <h1 className={stylesCommon['title-mobile']}>{title_m || title}</h1>
            <p className={styles['banner-desc']}>{desc}</p>
            <div className={styles['banner-btn-wrapper']}>
                {btnList.map(btn => {
                    if (btn.type === 'primary') {
                        return (
                            <NormalBtn
                                data={{
                                    link: btn.link,
                                    text: btn.text,
                                    btnType: 'big',
                                    className: `${styles['normal-btn']}`,
                                    trackInfo: btn.trackInfo
                                }}
                            />
                        );
                    }
                    return (
                        <a
                            href={btn.link}
                            target="_blank"
                            className={cn(styles['btn-link'], styles[btn.type])}
                            data-text={btn.text}
                            {...btn.trackInfo}
                        />
                    );
                })}
            </div>
        </div>
    );
};

const Banner = () => {
    const {swiperList} = data;
    const [bannerIndex, setBannerIndex] = useState(0);

    useCptDuration(id, {
        name: `${applicationName}-banner-停留时长`
    });

    const onBannerSlideChange = useCallback(swiper => {
        setBannerIndex(swiper.realIndex);
    }, []);

    return (
        <div className={styles.banner} id={id}>
            <img className={styles['banner-bg']} src={swiperList[bannerIndex].bannerBg} alt="banner背景图" />
            <img className={styles['banner-bg-m']} src={swiperList[bannerIndex].bannerBg_m} alt="banner背景图" />
            <div className={styles['banner-container-wrapper']}>
                <div
                    className={'no_rem-banner'}
                    onMouseEnter={() => {
                        const el = document.querySelector('.swiper-pagination-bullet-active');
                        el.classList.add('paused');
                    }}
                    onMouseLeave={() => {
                        const el = document.querySelector('.swiper-pagination-bullet-active');
                        el.classList.remove('paused');
                    }}
                >
                    <Swiper
                        {...bannerSwiperConfig}
                        className="banner-swiper-wrapper"
                        onSlideChange={onBannerSlideChange}
                    >
                        {swiperList.map(slide => {
                            return (
                                <SwiperSlide>
                                    <BannerSlide key={slide.id} data={slide} />
                                </SwiperSlide>
                            );
                        })}
                        <div className="swiper-pagination swiper-pagination-banner" />
                    </Swiper>
                </div>
            </div>
        </div>
    );
};

export default Banner;
